import groupBy from "lodash/groupBy";
import {updateQuoteWithSQFTData} from "./sqftQuotesHelper";

export const updateQuoteSqftFeatureIds = (cartItems) => (dispatch, getState) => {
  const store = getState();
  const { quotes } = store.quotesState;
  const itemsByQuote = groupBy(cartItems, 'currentQuote');

  Object.entries(itemsByQuote).forEach(([quoteId, cartItems]) => {
    const quote = quotes[Number(quoteId)];
    if (!quote) {
      return;
    }

    const { sqFtCalcData } = quote;

    if (!sqFtCalcData || !sqFtCalcData.countertops) {
      return;
    }

    const newSqFtCalcData = {
      ...sqFtCalcData,
      countertops: sqFtCalcData.countertops.map(countertop => {
        const cartItemFound = cartItems.find(cartItem =>
          (cartItem.sqftId === countertop.id) ||
          (Array.isArray(cartItem.sqftIds) && cartItem.sqftIds.includes(countertop.id))
        );
        return cartItemFound
          ? { ...countertop, featureId: cartItemFound.cartFeature.dbFeature.id }
          : countertop;
      })
    };
    updateQuoteWithSQFTData(newSqFtCalcData, Number(quoteId));
  });
};

// Remove countertops by sqft id(s) from a quote and persist the updated SQFT data.
// Accepts either a single id or an array of ids.
export const removeFromSqftCalcData = (quoteId, sqftIds) => (dispatch, getState) => {
  // Normalize quote
  const store = getState();
  const { quotes } = store.quotesState;
  const quote = quotes[Number(quoteId)];
  if (!quote) {
    return;
  }

  const { sqFtCalcData } = quote;
  if (!sqFtCalcData || !Array.isArray(sqFtCalcData.countertops)) {
    return;
  }

  // Normalize ids to a Set<string> for fast lookups and safe type coercion
  const ids = Array.isArray(sqftIds) ? sqftIds : [sqftIds];
  const idsSet = new Set(ids.map(id => String(id)));

  // Filter out countertops whose id is listed for removal
  const filteredCountertops = sqFtCalcData.countertops.filter(
    (ct) => !idsSet.has(String(ct.id))
  );

  const newSqFtCalcData = {
    ...sqFtCalcData,
    countertops: filteredCountertops,
  };

  // Persist the change (follows the same pattern as updateQuoteSqftFeatureIds)
  updateQuoteWithSQFTData(newSqFtCalcData, Number(quoteId));
};
